import {} from "@core/models/common.interface";
import { PasswordPolicy } from "@core/models/password-policy.interface";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const passwordActions = createActionGroup({
  source: "passwordPolicy",
  events: {
    "Set Password Policy": emptyProps(),
    "Set Password Policy Success": props<{
      passwordPolicy: PasswordPolicy;
    }>(),
    "Set Password Policy Fail": emptyProps(),
  },
});
